<div
    class="absolute bottom-0 right-0 flex items-center justify-center w-5 h-5 bg-red-600 rounded-l-lg shadow-lg cursor-pointer settings-cog z-90 bg-opacity-90 print:hidden"
    (click)="settingsDrawer.toggle()">
    <mat-icon
        class="text-white animate-spin-slow icon-size-3"
        [svgIcon]="'heroicons_solid:cog-8-tooth'"
    ></mat-icon>
</div>

<fuse-drawer
    class="w-screen z-999 min-w-screen sm:w-100 sm:min-w-100"
    fixed
    [mode]="'over'"
    [name]="'settingsDrawer'"
    [position]="'right'"
    #settingsDrawer
>
    <div class="flex flex-col w-full overflow-auto bg-card">
        <div
            class="flex flex-row items-center h-20 px-6 text-white min-h-20 bg-primary"
        >
            <mat-icon
                class="text-current icon-size-7"
                [svgIcon]="'heroicons_solid:cog-8-tooth'"
            ></mat-icon>
            <div class="ml-3 text-2xl font-semibold tracking-tight">
                Settings
            </div>
            <tms-close-button btnClass="ml-auto" (click)="settingsDrawer.close()" />
        </div>

        <div class="flex flex-col p-6">
            <!-- Theme -->
            <div class="font-semibold text-secondary text-md">THEME</div>
            <div class="grid grid-cols-2 gap-3 mt-6 sm:grid-cols-3">
                @for (theme of config.themes; track theme) {
                    <div
                        class="flex items-center justify-center px-4 py-3 rounded-full cursor-pointer bg-hover ring-inset ring-primary"
                        [class.ring-2]="config.theme === theme.id"
                        [ngClass]="theme.id"
                        (click)="setTheme(theme.id)"
                    >
                        <div
                            class="w-3 h-3 rounded-full flex-0 bg-primary"
                        ></div>
                        <div
                            class="ml-2.5 truncate font-medium leading-5"
                            [class.text-secondary]="config.theme !== theme.id"
                        >
                            {{ theme.name }}
                        </div>
                    </div>
                }
            </div>

            <hr class="my-8">

            <!-- Scheme -->
            <div class="font-semibold text-secondary text-md">SCHEME</div>
            <div class="grid grid-cols-3 gap-3 mt-6 justify-items-start">
                <!-- Auto -->
                <div
                    class="flex items-center py-3 pl-5 pr-6 rounded-full cursor-pointer bg-hover ring-inset ring-primary"
                    [class.ring-2]="config.scheme === 'auto'"
                    matTooltip="Automatically sets the scheme based on user's operating system's color scheme preference using 'prefer-color-scheme' media query."
                    (click)="setScheme('auto')"
                >
                    <div class="flex items-center overflow-hidden rounded-full">
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:bolt'"
                        ></mat-icon>
                    </div>
                    <div
                        class="flex items-center ml-2 font-medium leading-5"
                        [class.text-secondary]="config.scheme !== 'auto'"
                    >
                        Auto
                    </div>
                </div>
                <!-- Dark -->
                <div
                    class="flex items-center py-3 pl-5 pr-6 rounded-full cursor-pointer bg-hover ring-inset ring-primary"
                    [class.ring-2]="config.scheme === 'dark'"
                    (click)="setScheme('dark')"
                >
                    <div class="flex items-center overflow-hidden rounded-full">
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:moon'"
                        ></mat-icon>
                    </div>
                    <div
                        class="flex items-center ml-2 font-medium leading-5"
                        [class.text-secondary]="config.scheme !== 'dark'"
                    >
                        Dark
                    </div>
                </div>
                <!-- Light -->
                <div
                    class="flex items-center py-3 pl-5 pr-6 rounded-full cursor-pointer bg-hover ring-inset ring-primary"
                    [class.ring-2]="config.scheme === 'light'"
                    (click)="setScheme('light')"
                >
                    <div class="flex items-center overflow-hidden rounded-full">
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:sun'"
                        ></mat-icon>
                    </div>
                    <div
                        class="flex items-center ml-2 font-medium leading-5"
                        [class.text-secondary]="config.scheme !== 'light'"
                    >
                        Light
                    </div>
                </div>
            </div>

            <hr class="my-8">

            <!-- Layout -->
            <div class="font-semibold text-secondary text-md">LAYOUT</div>
            <div class="grid grid-cols-3 gap-3 mt-6">
                <!-- Empty -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('empty')"
                >
                    <div
                        class="flex flex-col h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'empty'"
                    >
                        <div
                            class="flex flex-col flex-auto bg-gray-50 dark:bg-gray-900"
                        ></div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'empty'"
                    >
                        Empty
                    </div>
                </div>

                <!-- Classic -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('classic')"
                >
                    <div
                        class="flex h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'classic'"
                    >
                        <div class="w-8 bg-gray-100 dark:bg-gray-800">
                            <div class="mx-1.5 mt-3 space-y-1">
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-col flex-auto border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                    class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'classic'"
                    >
                        Classic
                    </div>
                </div>

                <!-- Classy -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('classy')"
                >
                    <div
                        class="flex h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'classy'"
                    >
                        <div class="w-8 bg-gray-100 dark:bg-gray-800">
                            <div class="flex items-center mx-1 mt-1">
                                <div
                                    class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-1 h-1 ml-auto bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="ml-0.5 h-1 w-1 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                            <div
                                class="mx-auto mt-2.5 h-4 w-4 rounded-full bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div class="mx-1 mt-2 space-y-1">
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-col flex-auto border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                    class="flex items-center justify-end h-full mr-2"
                                >
                                    <div
                                        class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'classy'"
                    >
                        Classy
                    </div>
                </div>

                <!-- Compact -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('compact')"
                >
                    <div
                        class="flex h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'compact'"
                    >
                        <div class="w-5 bg-gray-100 dark:bg-gray-800">
                            <div
                                class="w-3 h-3 mx-auto mt-2 bg-gray-300 rounded-sm dark:bg-gray-700"
                            ></div>
                            <div
                                class="flex flex-col items-center w-full mt-2 space-y-1"
                            >
                                <div
                                    class="h-2.5 w-3 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-2.5 w-3 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-2.5 w-3 rounded-sm bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-col flex-auto border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                    class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'compact'"
                    >
                        Compact
                    </div>
                </div>

                <!-- Dense -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('dense')"
                >
                    <div
                        class="flex h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'dense'"
                    >
                        <div class="w-4 bg-gray-100 dark:bg-gray-800">
                            <div
                                class="w-2 h-2 mx-auto mt-2 bg-gray-300 rounded-sm dark:bg-gray-700"
                            ></div>
                            <div
                                class="flex flex-col items-center w-full mt-2 space-y-1"
                            >
                                <div
                                    class="w-2 h-2 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-2 h-2 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-2 h-2 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-col flex-auto border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                    class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'dense'"
                    >
                        Dense
                    </div>
                </div>

                <!-- Futuristic -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('futuristic')"
                >
                    <div
                        class="flex h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'futuristic'"
                    >
                        <div class="w-8 bg-gray-100 dark:bg-gray-800">
                            <div
                                class="flex h-full flex-auto flex-col space-y-1 px-1.5 py-3"
                            >
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                                <div class="flex-auto"></div>
                                <div
                                    class="h-1 bg-gray-300 rounded-sm dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-col flex-auto border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                    class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'futuristic'"
                    >
                        Futuristic
                    </div>
                </div>

                <!-- Thin -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('thin')"
                >
                    <div
                        class="flex h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'thin'"
                    >
                        <div class="w-3 bg-gray-100 dark:bg-gray-800">
                            <div
                                class="mx-auto mt-2 h-1.5 w-1.5 rounded-sm bg-gray-300 dark:bg-gray-700"
                            ></div>
                            <div
                                class="flex flex-col items-center w-full mt-2 space-y-1"
                            >
                                <div
                                    class="h-1.5 w-1.5 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1.5 w-1.5 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1.5 w-1.5 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1.5 w-1.5 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                                <div
                                    class="h-1.5 w-1.5 rounded-full bg-gray-300 dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-col flex-auto border-l">
                            <div class="h-3 bg-gray-100 dark:bg-gray-800">
                                <div
                                    class="mr-1.5 flex h-full items-center justify-end"
                                >
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'thin'"
                    >
                        Thin
                    </div>
                </div>

                <div class="col-span-2"></div>

                <!-- Centered -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('centered')"
                >
                    <div
                        class="flex h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'centered'"
                    >
                        <div
                            class="flex flex-col flex-auto mx-2 my-1 overflow-hidden border rounded-md"
                        >
                            <div
                                class="flex items-center h-3 bg-gray-100 dark:bg-gray-800"
                            >
                                <div class="ml-1.5 flex">
                                    <div
                                        class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-3 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-3 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-3 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                </div>
                                <div
                                    class="ml-auto mr-1.5 flex items-center justify-end"
                                >
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 ml-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'centered'"
                    >
                        Centered
                    </div>
                </div>

                <!-- Enterprise -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('enterprise')"
                >
                    <div
                        class="flex flex-col h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'enterprise'"
                    >
                        <div
                            class="flex items-center h-3 px-2 bg-gray-100 dark:bg-gray-800"
                        >
                            <div
                                class="w-2 h-2 bg-gray-300 rounded-full dark:bg-gray-700"
                            ></div>
                            <div
                                class="flex items-center justify-end ml-auto space-x-1"
                            >
                                <div
                                    class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div
                            class="flex items-center h-3 px-2 space-x-1 bg-gray-100 border-t border-b dark:bg-gray-800"
                        >
                            <div
                                class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                            ></div>
                            <div
                                class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                            ></div>
                            <div
                                class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                            ></div>
                            <div
                                class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                            ></div>
                        </div>
                        <div
                            class="flex flex-col flex-auto mx-2 my-1 overflow-hidden border rounded"
                        >
                            <div
                                class="flex flex-auto bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'enterprise'"
                    >
                        Enterprise
                    </div>
                </div>

                <!-- Material -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('material')"
                >
                    <div
                        class="flex flex-col h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'material'"
                    >
                        <div
                            class="flex flex-col flex-auto mx-2 my-1 overflow-hidden border rounded"
                        >
                            <div
                                class="flex items-center h-4 px-2 bg-gray-100 dark:bg-gray-800"
                            >
                                <div
                                    class="w-2 h-2 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="flex items-center justify-end ml-auto space-x-1"
                                >
                                    <div
                                        class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                    <div
                                        class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                    ></div>
                                </div>
                            </div>
                            <div
                                class="flex items-center h-2 px-2 space-x-1 bg-gray-100 dark:bg-gray-800"
                            >
                                <div
                                    class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                            </div>
                            <div
                                class="flex flex-auto border-t bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'material'"
                    >
                        Material
                    </div>
                </div>

                <!-- Modern -->
                <div
                    class="flex flex-col cursor-pointer"
                    (click)="setLayout('modern')"
                >
                    <div
                        class="flex flex-col h-20 overflow-hidden border-2 rounded-md hover:opacity-80"
                        [class.border-primary]="config.layout === 'modern'"
                    >
                        <div
                            class="flex items-center h-4 px-2 bg-gray-100 border-b dark:bg-gray-800"
                        >
                            <div
                                class="w-2 h-2 bg-gray-300 rounded-full dark:bg-gray-700"
                            ></div>
                            <div class="flex items-center h-3 ml-2 space-x-1">
                                <div
                                    class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-3 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                            </div>
                            <div
                                class="flex items-center justify-end ml-auto space-x-1"
                            >
                                <div
                                    class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                                <div
                                    class="w-1 h-1 bg-gray-300 rounded-full dark:bg-gray-700"
                                ></div>
                            </div>
                        </div>
                        <div class="flex flex-col flex-auto">
                            <div
                                class="flex flex-auto bg-gray-50 dark:bg-gray-900"
                            ></div>
                        </div>
                    </div>
                    <div
                        class="mt-2 font-medium text-center text-secondary text-md"
                        [class.text-primary]="config.layout === 'modern'"
                    >
                        Modern
                    </div>
                </div>
            </div>
        </div>
    </div>
</fuse-drawer>
